export const CHANGE_LANGUAGE = "@@profile/CHANGE_LANGUAGE";
export const CHANGE_START_DATE = "CHANGE_START_DATE";
export const CHANGE_END_DATE = "CHANGE_END_DATE";
export const CHANGE_CATEGORY = "CHANGE_CATEGORY";
export const CHANGE_CURRENT_CATEGORIES = "CHANGE_CURRENT_CATEGORIES";
export const FILTER_BY_MAIN_CATEGORY = "FILTER_BY_MAIN_CATEGORY";
export const FILTER_BY_SOUND = "FILTER_BY_SOUND";
export const UPDATE_CURRENT_CATEGORIES = "UPDATE_CURRENT_CATEGORIES";
export const RESET = "@@profile/RESET";
export const UPDATE_GEO = "UPDATE_GEO";
export const UPDATE_BOUNDS = "UPDATE_BOUNDS";
export const REQUEST_GEO_LOCATION = "REQUEST_GEO_LOCATION";
export const RECEIVE_GEO_LOCATION = "RECEIVE_GEO_LOCATION";

export const SET_DEVICE_LOCATION = "SET_DEVICE_LOCATION";
export const SYNC_DEVICE_LOCATION = "SYNC_DEVICE_LOCATION";
export const SET_DOWNLOAD_PERC = "SET_DOWNLOAD_PERC";

export const SET_TIMES_GEO = "SET_TIMES_GEO";

export function setTimesGeo() {
  return { type: SET_TIMES_GEO, payload: {} };
}
export function setDevicePerc(percentage) {
  return { type: SET_DOWNLOAD_PERC, payload: { percentage } };
}

export function requestGeoLocation(locationName) {
  return { type: REQUEST_GEO_LOCATION, payload: { locationName } };
}
export function receiveGeoLocation(info) {
  return { type: RECEIVE_GEO_LOCATION, payload: { info } };
}
export function setDeviceLocation(locationLat, locationLng) {
  return { type: SET_DEVICE_LOCATION, payload: { locationLat, locationLng } };
}

export function syncDeviceLocation() {
  return { type: SYNC_DEVICE_LOCATION, payload: {} };
}
export function updateBounds(latRange, lngRange) {
  return { type: UPDATE_BOUNDS, payload: { latRange, lngRange } };
}

export function updateGeo(lat, lng, zoom) {
  return { type: UPDATE_GEO, payload: { lat, lng, zoom } };
}

export function changeSelectedCategory(selectedCategory) {
  return { type: CHANGE_CATEGORY, payload: { selectedCategory } };
}
export function changeStartDate(startDate) {
  return { type: CHANGE_START_DATE, payload: { startDate } };
}
export function changeEndDate(endDate) {
  return { type: CHANGE_END_DATE, payload: { endDate } };
}

export function changeLanguage(language) {
  return { type: CHANGE_LANGUAGE, payload: { language } };
}

export function changeCurrentCategories(currentCategories) {
  return { type: CHANGE_CURRENT_CATEGORIES, payload: { currentCategories } };
}

export function filterByMainCategory(mainCategory) {
  return { type: FILTER_BY_MAIN_CATEGORY, payload: { mainCategory } };
}

export function filterBySound(soundCategory) {
  return { type: FILTER_BY_SOUND, payload: { soundCategory } };
}

export function reset() {
  return { type: RESET };
}
